// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3.5 13.5C2.4 13.5 1.5 12.6 1.5 11.5V4.25C1.5 3.15 2.4 2.25 3.5 2.25H5.15C5.65 2.25 6.08 2.48 6.4 2.86L6.88 3.43C7.2 3.81 7.63 4.05 8.13 4.05H12.5C13.6 4.05 14.5 4.95 14.5 6.05V11.5C14.5 12.6 13.6 13.5 12.5 13.5H3.5Z',
];
